import {
  ApiKey,
  AppConnectivity,
  Asset,
  Categories,
  ChartRelationship,
  CicsDb2Connection,
  Connect,
  ConnectionFlowUsage,
  ConnectionSignal,
  DataBase,
  Events,
  Floorplan,
  FlowConnection,
  FlowSequence,
  GuiManagement,
  Image,
  IotPlatform,
  LassoPolygon,
  License,
  ListNumbered,
  LocationFilled,
  Logout,
  Map as MapIcon,
  Notebook,
  Search,
  Sensor,
  Settings,
  SquareOutline,
  TagGroup,
  Tools,
  WarningAlt,
  WarningAltFilled,
} from "@carbon/icons-react";
import { createOverlayIcon } from "./iconUtils";

export const SECTION_ICONS = {
  platformConfiguration: GuiManagement,
  locations: MapIcon,
  resources: Asset,
  sensorGroups: TagGroup,
  users: Events,
  apiKeys: ApiKey,
  sensors: Sensor,
  sensorTraits: Connect,
  attributeDefinitions: Categories,
  traitDefinitions: ChartRelationship,
  floorplans: Floorplan,
  rfidReaders: IotPlatform,
  dataTasks: AppConnectivity,
  alerts: WarningAlt,
  inventory: ListNumbered,
  locationSequences: FlowSequence,
  attributeValues: DataBase,
  search: Search,
  licence: License,
  settings: Settings,
} as const;

export const BLOCK_LEVEL_ICONS = {
  locationHistory: Notebook,
  images: Image,
  custom: Tools,
  relatedData: CicsDb2Connection,
  steps: FlowConnection,
  completions: ConnectionFlowUsage,
  logout: Logout,
  antennas: ConnectionSignal,
} as const;

export type SectionKey = keyof typeof SECTION_ICONS;

/**
 * Floorplan area drawing tools. Both areas are drawn with the same two
 * geometries, so the geometry is the base glyph and the area type is the corner
 * overlay: a pin for location areas, a warning triangle for alert zones. Both
 * overlays inherit the icon color, like every other Carbon icon.
 */
export const AREA_TOOL_ICONS = {
  locationRectangle: createOverlayIcon(SquareOutline, LocationFilled, {
    name: "LocationRectangle",
  }),
  locationSpline: createOverlayIcon(LassoPolygon, LocationFilled, {
    name: "LocationSpline",
  }),
  alertRectangle: createOverlayIcon(SquareOutline, WarningAltFilled, {
    name: "AlertRectangle",
  }),
  alertSpline: createOverlayIcon(LassoPolygon, WarningAltFilled, {
    name: "AlertSpline",
  }),
} as const;
